/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Law_P1Inputs */

const es_tyc_law_p1 = /** @type {(inputs: Tyc_Law_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estos Terminos se rigen e interpretaran conforme a las leyes de los Estados Unidos de America. Cualquier disputa legal se sometera exclusivamente a los tribunales estatales o federales ubicados en el Condado de Santa Clara, California.`)
};

const en_tyc_law_p1 = /** @type {(inputs: Tyc_Law_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These Terms are governed by and construed in accordance with the laws of the United States of America. Any legal dispute shall be submitted exclusively to the state or federal courts located in Santa Clara County, California.`)
};

/**
* | output |
* | --- |
* | "These Terms are governed by and construed in accordance with the laws of the United States of America. Any legal dispute shall be submitted exclusively to th..." |
*
* @param {Tyc_Law_P1Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_law_p1 = /** @type {((inputs?: Tyc_Law_P1Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Law_P1Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_law_p1(inputs)
	return en_tyc_law_p1(inputs)
});
export { tyc_law_p1 as "tyc.law.p1" }